import gql from 'graphql-tag';

import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendPerformanceCenterCustomerResource,
  BackendQueryCustomerResourceArgs,
} from 'src/types/backend';

import { FRAGMENT_CUSTOMER_RESOURCE } from './schema';

const QUERY = gql`
  query CustomerResources($customerId: ID!) {
    customerResource(customerId: $customerId) {
      ...PerformanceCenterCustomerResource
    }
  }
  ${FRAGMENT_CUSTOMER_RESOURCE}
`;

type Variables = Pick<BackendQueryCustomerResourceArgs, 'customerId'>;
type Result = BackendPerformanceCenterCustomerResource[];

export const queryCustomerResources = async (variables: Variables) => {
  const result = await executeGqlQuery({ query: QUERY, variables });
  return getSingleProp<Result>(result.data);
};
